<div [ngClass]="['mp-autocomplete', size, customClasses, outlinedColor ?? 'primary', outlinedStyle ?? 'solid']"
  #autocompleteField
  [class.outlined]="outlined"
  [class.opened]="displayDropdown()"
  [class.disabled]="disabled"
  [class.readonly]="isReadOnly"
  [class.with-icon]="faIcon"
  (keydown)="onKeydownArrowDown($event)">
  <i class="mp-autocomplete-icon {{faIcon}} {{outlinedColor ?? 'primary'}}"
    [class.without-value]="!autocompleteValue"
  ></i>
  <ng-container>
    <input id="mp-value-autocomplete" #mpValueAutocomplete
      autocomplete="off"
      [readonly]="disabled || isReadOnly"
      class="mp-autocomplete-field"
      [class.without-value]="!autocompleteValue"
      [placeholder]="label | translate"
      [(ngModel)]="autocompleteValue"
      [ngModelOptions]="{standalone: true}"
      (ngModelChange)="onValueChanged()"
      [mpTooltip]="getOverflowTooltip(autocompleteValue)"
      [mpTooltipDisabled]="disabled || !isEllipsisActive"
      (keydown.enter)="selectHighlightedOption()"
      />
    </ng-container>
  </div>

  @if (displayDropdown()) {
    <app-mp-autocomplete-dropdown
      [anchor]="autocompleteFieldElementRef"
      (keydown)="onDocumentKeydown($event)">
      <div #autocompleteOptionsRef tabindex="0" class="autocomplete-option-list">
        @for (option of autocompleteOptions; track option; let index = $index) {
          <div class="autocomplete-option"
            [class.highlighted]="index === highlightedOptionIndex"
            [class.selected]="isSelectedOption(option)"
            (click)="optionSelected(option)">
            <span>{{ getOptionLabel(option) | translate }}</span>
          </div>
        }
      </div>
    </app-mp-autocomplete-dropdown>
  }



